export const iconFontAwesomeAnimalsCrow = (
	<i className="fa-solid fa-crow"></i>
);
